import type { Arenda, TipResursa } from './api';
import { useRedaktor } from './useRedaktor';

/**
 * ПРЕЖНЕЕ ИМЯ ХУКА АРЕНДЫ (`s713`). С `s719` аренда берётся ПРИ ОТКРЫТИИ карточки, а не по фокусу
 * в поле ответа (слова владельца: «захват при фокусе и мягкий режим недостаточны»), и вся механика
 * живёт в `useRedaktor`. Это имя оставлено местам, которые его уже зовут: подпись прежняя,
 * `vzyat()` теперь только отмечает действие человека. Новый код зовёт `useRedaktor`.
 */
export interface SostoyanieArendy {
  arenda: Arenda | null;
  /** Сервер аренду знает. Нет — прежний сервер, экран молчит. */
  est: boolean;
  /** Редактировать нельзя: держит другой человек, аренда истекла или ещё не взята. */
  tolkoProsmotr: boolean;
  /** Секунд до истечения моей блокировки; `null` — блокировка не моя. */
  ostalos: number | null;
  /** Пора предупредить: до истечения осталось меньше порога сервера. */
  skoroIstechyot: boolean;
  /** Слово последнего отказа двери аренды (перехвачено, утрачено, нет права). */
  slovo: string | null;
  kod: string | null;
  idyot: boolean;
  vzyat: (perenesti?: boolean) => Promise<boolean>;
  prodolzhit: () => Promise<void>;
  perehvatit: () => Promise<void>;
  otmetitAktivnost: () => void;
  svobodno?: boolean;
}

export function useArenda(tip: TipResursa, id: number | undefined, sServera: Arenda | null | undefined): SostoyanieArendy {
  return useRedaktor(tip, id, { sServera: sServera ?? null });
}
